// extracted by mini-css-extract-plugin
export default {"root":"Rp6nVPajInNBVbxF_TZ2e"};